import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["items", "pagination", "next", "status"]

  connect() {
    this.abortController = new AbortController()
    if (typeof IntersectionObserver === "undefined") return
    this.observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) this.load()
    }, { rootMargin: "300px" })
    this.observeNext()
  }

  disconnect() {
    this.observer?.disconnect()
    this.abortController.abort()
  }

  observeNext() {
    this.observer?.disconnect()
    if (this.hasNextTarget) this.observer?.observe(this.nextTarget)
  }

  async load(event) {
    event?.preventDefault()
    if (this.loading || !this.hasNextTarget) return
    this.loading = true
    this.statusTarget.textContent = "Loading more results…"
    try {
      const response = await fetch(this.nextTarget.href, { signal: this.abortController.signal, headers: { Accept: "text/html" } })
      if (!response.ok || response.redirected) throw new Error("Results unavailable")
      const page = new DOMParser().parseFromString(await response.text(), "text/html")
      const items = page.querySelector('[data-result-history-target="items"]')
      const pagination = page.querySelector('[data-result-history-target="pagination"]')
      if (!items || !pagination) throw new Error("Results unavailable")
      this.itemsTarget.append(...items.children)
      this.paginationTarget.replaceChildren(...pagination.children)
      this.statusTarget.textContent = "More results loaded."
      this.observeNext()
    } catch (error) {
      if (error.name !== "AbortError") {
        this.statusTarget.textContent = "Couldn't load more results. Select Load more results to retry."
        this.observer?.disconnect()
      }
    } finally {
      this.loading = false
    }
  }
}
